<template>
  <div>
    <vxe-card>
      <template #title>
        <vxe-input v-model="query['item.no']" placeholder="business.label.itemNo" @clear="refresh()" @keydown.native.enter="refresh()"/>
        <vxe-input v-model="query['item.name']" placeholder="business.label.itemName" @clear="refresh()" @keydown.native.enter="refresh()"/>
        <vxe-input v-model="query['lot.no']" placeholder="business.label.lot" @clear="refresh()" @keydown.native.enter="refresh()"/>
      </template>
      <template #extra>
        <vxe-button content="button.query" icon="vxe-icon-search" status="primary" @click="refresh()"/>
        <vxe-button content="button.reset" icon="vxe-icon-undo" status="danger" @click="reset"/>
      </template>
      <vxe-table ref="table" :data="data" :expand-config="{labelField:'item.no',accordion: true, toggleMethod: this.toggleMethod, iconClose:'vxe-icon-square-plus',iconOpen:'vxe-icon-square-minus'}" :loading="loading">
        <vxe-column fixed="left" type="seq" width="40"/>
        <vxe-column v-if="typeOptions[type].obtain" title="business.label.itemNo" type="expand" width="120">
          <template #content="{ row }">
            <vxe-grid :columns="childCols" :data="row.details" :loading="expanding" height="auto"/>
          </template>
        </vxe-column>
        <vxe-column v-else field="item.no" title="business.label.itemNo" width="80"/>
        <vxe-column field="item.name" title="business.label.itemName"/>
        <vxe-column field="pack.specification" title="business.label.specification"/>
        <vxe-column field="pack.uom" title="business.label.uom" width="60"/>
        <vxe-column field="pack.factor" title="business.label.factor" width="60"/>
        <vxe-column field="plannedQuantity" title="business.label.plannedQuantity"/>
        <vxe-column v-if="typeOptions[type].less" field="lessnessQuantity" title="business.label.lessnessQuantity"/>
        <vxe-column v-if="typeOptions[type].obtain" field="obtainedQuantity" title="business.label.obtainedQuantity"/>
        <vxe-column field="lot.no" title="business.label.lot"/>
        <vxe-column field="batch.no" title="business.label.batchNo"/>
        <vxe-column field="location.no" title="business.label.locationNo"/>
        <vxe-column v-if="typeOptions[type].obtain" fixed="right" title="business.label.operate" width="auto">
          <vxe-button-group slot-scope="{row}" mode="text">
            <vxe-button content="button.obtain" icon="vxe-icon-search" status="primary" @click.stop="obtain(row)"/>
          </vxe-button-group>
        </vxe-column>
      </vxe-table>
      <template #footer>
        <vxe-pager :current-page="page" :loading="loading" :page-size="size" :total="contentSize" @page-change="pageChange"/>
      </template>
    </vxe-card>
    <obtain-modal ref="obtainModal" :type="type" @success="refresh()"/>
  </div>
</template>

<script>
import { findAll } from '@/api/Api'
import ObtainModal from '@/views/outbound/issue/ObtainModal.vue'

export default {
  name: 'IssueDetail',
  components: { ObtainModal },
  props: {
    type: { type: String }
  },
  data() {
    return {
      loading: false,
      expanding: false,
      data: [],
      query: {
        original: true,
        'item.no': '',
        'item.name': '',
        'lot.no': ''
      },
      orderId: null,
      page: 1,
      size: 15,
      contentSize: 0,
      typeOptions: {
        appointed: {
          less: false,
          obtain: true
        },
        refundable: {
          less: false,
          obtain: true
        },
        shortable: {
          less: false,
          obtain: true
        },
        suspended: {
          less: true,
          obtain: true
        },
        oneStep: {
          less: false,
          obtain: false
        }
      },
      childCols: [
        { type: 'seq', title: 'business.label.index' },
        { field: 'pack.specification', title: 'business.label.specification' },
        { field: 'pack.uom', title: 'business.label.uom' },
        { field: 'pack.factor', title: 'business.label.factor' },
        { field: 'lot.no', title: 'business.label.lot' },
        { field: 'batch.no', title: 'business.label.batchNo' },
        { field: 'location.no', title: 'business.label.location' },
        { field: 'actualQuantity', title: 'business.label.obtainedQuantity' }
      ]
    }
  },
  methods: {
    toggleMethod({ expanded, row }) {
      if (expanded) {
        this.expanding = true
        findAll('dispatchObtainDetailFactory', { 'parent.id': row.id, original: false }).then(res => {
          if (res.success) {
            row['details'] = res.result
          }
        }).finally(() => this.expanding = false)
      }
      return true
    },
    pageChange({ currentPage, pageSize }) {
      this.page = currentPage
      this.size = pageSize
      this.fetch()
    },
    fetch() {
      if (!this.orderId) {
        return this.$message.warning('请选择一行单据再查询明细信息')
      }
      this.loading = true
      const args = {
        ...this.typeOptions[this.type],
        ...this.query,
        'order.id': this.orderId
      }
      findAll('dispatchObtainDetailFactory', args, this.page, this.size).then(res => {
        if (res.success) {
          this.data = res.result
          this.contentSize = res.contentSize
        }
      }).finally(() => this.loading = false)
    },
    refresh(id) {
      if (id) this.orderId = id
      this.page = 1
      this.fetch()
    },
    reset() {
      this.query['item.no'] = ''
      this.query['item.name'] = ''
      this.query['lot.no'] = ''
      this.refresh()
    },
    clear() {
      this.data = []
    },
    obtain(row) {
      this.$refs.obtainModal.open(row, this.orderId)
    }
  }
}
</script>